import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { PostAPI } from '../../../ApiServices/ApiServices'; // adjust the path
import Assets from "../../../Assets/Assets";

const NewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Email passed from previous page (VerifyEmail)
  const email = location?.state?.email || "mohammedshafeek077@gmail.com";

  const [eyeOpen, setEyeOpen] = useState(false);
  const [eyeOpenTwo, setEyeOpenTwo] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const resetPassword = async () => {
    // ✅ Step 1: Validation checks
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill out both password fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    // ✅ Step 2: Prepare data
    const url = "/auth/doctor/reset-password";
    const data = { email, new_password: newPassword };

    // ✅ Step 3: API Call
    try {
      await PostAPI({ url, data }, async (res) => {
        if (res?.success && res?.statusCode === 200) {
          toast.success(res?.message || "Password reset successfully");

          // ✅ Redirect to login after success
          setTimeout(() => navigate("/"), 1500);
        } else {
          toast.error(res?.message || "Failed to reset password. Please try again.");
        }
      });
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="login-form container">
      <div className="right-content">
        <h4 className="form-head color-txt">Reset Password</h4>
        <h4 className="form-head">Set your New Password</h4>
      </div>

      <div className="form-box">
        <Form>
          {/* New Password */}
          <Form.Group className="mb-3" controlId="formNewPassword">
            <Form.Label>New Password</Form.Label>
            <div className="eye-setup">
              <Form.Control
                type={eyeOpen ? "text" : "password"}
                placeholder="Enter New Password"
                className="login-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <img
                src={eyeOpen ? Assets.eyeOpen : Assets.eyeClose}
                alt="toggle visibility"
                className="eye-img"
                onClick={() => setEyeOpen(!eyeOpen)}
              />
            </div>
          </Form.Group>

          {/* Confirm Password */}
          <Form.Group className="mb-3" controlId="formConfirmPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <div className="eye-setup">
              <Form.Control
                type={eyeOpenTwo ? "text" : "password"}
                placeholder="Enter Confirm Password"
                className="login-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <img
                src={eyeOpenTwo ? Assets.eyeOpen : Assets.eyeClose}
                alt="toggle visibility"
                className="eye-img"
                onClick={() => setEyeOpenTwo(!eyeOpenTwo)}
              />
            </div>
          </Form.Group>

          <Button variant="primary" onClick={resetPassword} className="mb-3">
            Confirm
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default NewPassword;
